import React, { useState, useEffect } from "react";

const VideoFormModal = ({
  show,
  onClose,
  onSubmit,
  video = null,
  provincias,
}) => {
  const [formData, setFormData] = useState({
    titulo: "",
    descripcion: "",
    content: "",
    url: "",
    usuarios_id: "",
    status: "ACTIVO",
    imagen: "",
    imagen_url: "",
    provincia: "",
  });

  useEffect(() => {
    if (video) {
      setFormData({ ...video, imagen_url: video.imagen });
    } else {
      setFormData({
        titulo: "",
        descripcion: "",
        content: "",
        url: "",
        usuarios_id: "",
        status: "ACTIVO",
        imagen: "",
        imagen_url: "",
        provincia: "",
      });
    }
  }, [video]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ target: { name: "guardar" } }, formData);
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content shadow-lg border-0 rounded-4">
          <form onSubmit={handleSubmit}>
            <div className="modal-header text-dark rounded-top-4">
              <h5 className="modal-title fw-bold">
                {video ? "Editar Video" : "Agregar Nuevo Video"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
              ></button>
            </div>

            <div
              className="modal-body px-4 py-3"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="row g-3">
                <div className="col-md-12">
                  <div
                    className="w-100 d-flex items-align-center justify-content-center bg-white overflow-hidden"
                    style={{
                      height: "150px",
                    }}
                  >
                    <img
                      src={`https://www.antesala.com.ar/assets/img/videos/${formData.imagen_url}`}
                      alt="Video"
                      className="h-100 m-auto"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Título</label>
                  <input
                    type="text"
                    name="titulo"
                    value={formData.titulo}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Imagen (URL)</label>
                  <input
                    type="file"
                    name="imagen"
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        imagen: e.target.files[0],
                        imagen_url: URL.createObjectURL(e.target.files[0]),
                      }));
                    }}
                    className="form-control rounded-3"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Descripción</label>
                  <textarea
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    rows="2"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Contenido</label>
                  <textarea
                    name="content"
                    value={formData.content}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    rows="2"
                  />
                </div>

                <div className="col-md-12">
                  <label
                    for="email"
                    className="form-label text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    Provincia
                  </label>
                  <select
                    class="form-select"
                    aria-label="Default select example"
                    name="provincia"
                    onChange={(event) => handleChange}
                  >
                    {formData.provincia == "" ? <option selected></option> : ""}
                    {provincias
                      ? provincias.map((p) => {
                          if (p.provincia == formData.provincia) {
                            return <option selected>{p.provincia}</option>;
                          } else {
                            return (
                              <option value={p.provincia}>{p.provincia}</option>
                            );
                          }
                        })
                      : ""}
                  </select>
                </div>

                <div className="col-md-12">
                  <label className="form-label">URL</label>
                  <input
                    type="url"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                    className="form-control rounded-3"
                  />
                </div>

                <div className="col-md-12 d-flex justify-content-center mb-4">
                  <iframe
                    width="560"
                    height="315"
                    src={formData.url}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light rounded-bottom-4">
              <button
                type="submit"
                className="btn btn-custom-naranja text-white px-4"
              >
                {video ? "Actualizar" : "Guardar"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VideoFormModal;
